// SPDX-License-Identifier: AGPL-3.0-or-later

import {Messages} from '@app/features/channel/components/ChannelMessages';
import type {Channel} from '@app/features/channel/models/Channel';
import styles from '@app/features/voice_scene/components/VoiceSceneChatPanel.module.css';
import {msg} from '@lingui/core/macro';
import {useLingui} from '@lingui/react/macro';
import {clsx} from 'clsx';

const ROOM_CHAT_DESCRIPTOR = msg({
	message: 'Voice channel chat',
	comment: "Voice call 3D room: accessible name of the panel that shows this voice channel's messages over the room.",
});

// Fluxer's own message list for this voice channel, in the room's toolbar over the message box. The room's material is
// black on every theme, so the list keeps the dark palette. Embedded, its rows always show avatars, to tell at a glance
// who in the room is talking. With the focus here, the room leaves its keys alone (RoomInput).
export function VoiceSceneChatPanel({channel}: {channel: Channel}) {
	const {i18n} = useLingui();
	return (
		<section
			className={clsx(styles.panel, 'theme-coal')}
			aria-label={i18n._(ROOM_CHAT_DESCRIPTOR)}
			data-room-chat=""
			data-flx="voice-scene.voice-scene-chat-panel.panel"
		>
			<Messages key={channel.id} channel={channel} embedded data-flx="voice-scene.voice-scene-chat-panel.messages" />
		</section>
	);
}
